/* angular:styles/component:css;9101021e021ae84b29c54df850656214587a32fc8a9f277d6277cd4653e01714;/src/src/app/edge/settings/alerting/component/alerting.component.ts */
ion-select {
  max-width: 100% !important;
  margin: auto;
  padding: 0;
  vertical-align: middle;
}
/*# sourceMappingURL=alerting.component.css.map */
